//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref, computed, onMounted } from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';
import { useUserShouHouOrder } from '@bee-hole/coms';
import List from '~/components/Order/OrderList';
import AfterSalesDetail from '~/components/Order/AfterDetail';
import Paginate from '~/components/Paginate';

export default {
  name: 'AfterSalesTab',
  components: {
    SfButton,
    List,
    AfterSalesDetail,
    Paginate,
  },
  setup() {
    const orders = ref([]);
    const totalOrders = ref(0);
    const currentOrder = ref(null);
    const queryParams = ref({ page_no: 1, page_size: 10 });

    const { orderLists, shouhouOrderGet, total } =
      useUserShouHouOrder('shouhou');

    const totalPageNo = computed(() => {
      return Math.ceil(totalOrders.value / queryParams.value.page_size) || 1;
    });

    const loadOrders = async () => {
      await shouhouOrderGet({
        status: 'ORDER_AFTER_SALE',
        page_no: queryParams.value.page_no,
        page_size: queryParams.value.page_size,
      });
      orders.value = orderLists.value;
      totalOrders.value = total.value;
    };

    const handlePageChange = async (page) => {
      queryParams.value.page_no = page;
      await loadOrders();
    };

    const setCurrentOrder = (order) => {
      console.log('setCurrentOrder', order);
      currentOrder.value = order;
    };

    const resetCurrentOrder = () => {
      currentOrder.value = null;
    };

    onMounted(async () => {
      await loadOrders();
    });

    return {
      orders,
      totalOrders,
      currentOrder,
      queryParams,
      totalPageNo,
      loadOrders,
      handlePageChange,
      setCurrentOrder,
      resetCurrentOrder,
    };
  },
};
